export const FormCDSTestIds = {
  // Dynamic
  getCloseIconId: name => `form.close-icon-${name}`,
};
